import { ds24cart_id } from "./ds24cart_id";

export function ds24cart_jsonp_args()
{
    var args = 'cart_id='+ds24cart_id();

    if (window.DS24_NETTO) {
        args += '&netto=Y';
    }

    if (window.DS24_OF_AS_POPUP) {
        args += '&orderform_as_popup=Y';
    }

    if (window.DS24_CURRENCY_SYMBOL) {
        args += '&currency_symbol=Y';
    }

    if (window.DS24_CURRENCY) {
        args += '&currency='+encodeURIComponent(window.DS24_CURRENCY);
    }


    if (window.DS24_ORDERFORM_ID) {
        args += '&orderform_id='+encodeURIComponent(window.DS24_ORDERFORM_ID);
    }

    if (window.DS24_RETURN_URL) {
        args += '&return_url='+encodeURIComponent(window.DS24_RETURN_URL);
    }

    if (window.DS24_THANKYOU_URL) {
        args += '&thankyou_url='+encodeURIComponent(window.DS24_THANKYOU_URL);
    }

    if (window.DS24_CHECKOUT_URL) {
        args += '&checkout_url='+encodeURIComponent(window.DS24_CHECKOUT_URL);
    }

    if (window.DS24_LANGUAGE) {
        args += '&language='+encodeURIComponent(window.DS24_LANGUAGE);
    }

    if (window.DS24_NO_RETURN_BUTTON) {
        args += '&no_return_button='+encodeURIComponent(window.DS24_NO_RETURN_BUTTON);
    }

    if (window.DS24_UPSELL) {
        args += '&upsell='+encodeURIComponent(window.DS24_UPSELL);
    }

    if (window.DS24_TRACKING_PARAM) {
        args += '&tracking_param='+encodeURIComponent(window.DS24_TRACKING_PARAM);
    }
    
    if (window.DS24_CONTINUE_URL) {
        args += '&continue_url='+encodeURIComponent(window.DS24_CONTINUE_URL);
    }
    
    if (window.DS24_CONTINUE_LABEL) {
        args += '&continue_label='+encodeURIComponent(window.DS24_CONTINUE_LABEL);
    }

    if (window.DS24_QUANTITY_RO) {
        args += '&quantity_readonly=Y';
    }

    if (window.DS24_SHOW_CART_SUM) {
        args += '&show_total_amount='+encodeURIComponent(window.DS24_SHOW_CART_SUM);
    }

    if (window.DS24_SHOW_CART_ITEMS) {
        args += '&show_cart_items='+encodeURIComponent(window.DS24_SHOW_CART_ITEMS);
    }

    if (window.DS24_ON_CART_CHANGE) {
        args += '&on_cart_change='+encodeURIComponent(window.DS24_ON_CART_CHANGE);
    }

    if (window.DS24_INFO_STICKY) {
        args += '&info_sticky=Y';
    }

    if (window.DS24_VOUCHER) {
        args += '&voucher='+encodeURIComponent(window.DS24_VOUCHER);
    }

    return args;
}